import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Config {
  name: string;
  api_token: string;
}

export interface ConfigInfor {
  errors: unknown;
  configData: Config;
  configDataUpdate: Config;
  isAuthenticated: boolean;
}

@Module
export default class ConfigModule extends VuexModule implements ConfigInfor {
  errors = {};
  configData = {} as Config;
  configDataUpdate = {} as Config;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get getConfigInfo() {
    return this.generalConfigData;
  }
  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.GENERAL_CONFIG_DATA](configData) {
    this.generalConfigData = configData;
  }

  @Mutation
  [Mutations.GENERAL_CONFIG_UPDATE_DATA](configDataUpdate) {
    this.configDataUpdate = configDataUpdate;
  }

  @Action
  [Actions.GENERAL_CONFIG](data) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/config", data)
        .then(({ data }) => {
          this.context.commit(Mutations.GENERAL_CONFIG_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.GENERAL_CONFIG_UPDATE](data) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/config/upsert", data)
        .then(({ data }) => {
          this.context.commit(Mutations.GENERAL_CONFIG_UPDATE_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
